// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1BB5r","title":"BackImages_title__UhS9M","images":"BackImages_images__3l3WQ"};